import CustomText from "../components/atomic/CustomText";
import LandingPageLayout from "../layouts/LandingPageLayout";

function NoConnectionPage(): JSX.Element {
  return (
    <LandingPageLayout>
      <div className="flex h-full w-full justify-center items-center">
        <CustomText
          text={"Please check your network connection and try again"}
          fontWeight="font-semibold"
          fontSize="text-2xl"
        />
      </div>
    </LandingPageLayout>
  );
}

export default NoConnectionPage;
